var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.5C0 2.01472 2.01472 0 4.5 0H19.5C21.9853 0 24 2.01472 24 4.5V19.5C24 21.9853 21.9853 24 19.5 24H4.5C2.01472 24 0 21.9853 0 19.5V16C0 14.3431 1.34315 13 3 13C4.65685 13 6 14.3431 6 16V18H18V6H6C6 7.65685 4.65685 9 3 9C1.34315 9 0 7.65685 0 6V4.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 50C21.9853 50 24 47.9853 24 45.5L24 30.5C24 28.0147 21.9853 26 19.5 26L4.5 26C2.01472 26 -2.62172e-07 28.0147 -2.32535e-07 30.5L-5.3662e-08 45.5C-2.40253e-08 47.9853 2.01472 50 4.5 50L8 50C9.65685 50 11 48.6569 11 47C11 45.3431 9.65685 44 8 44L6 44L6 32L18 32L18 44C16.3431 44 15 45.3431 15 47C15 48.6569 16.3431 50 18 50L19.5 50Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 -1.96701e-07C47.9853 -8.80661e-08 50 2.01472 50 4.5L50 19.5C50 21.9853 47.9853 24 45.5 24L30.5 24C28.0147 24 26 21.9853 26 19.5L26 4.5C26 2.01472 28.0147 -9.61007e-07 30.5 -8.52372e-07L34 -6.99382e-07C35.6569 -6.26959e-07 37 1.34315 37 3C37 4.65685 35.6569 6 34 6L32 6L32 18L44 18L44 6C42.3431 6 41 4.65685 41 3C41 1.34315 42.3431 -3.34692e-07 44 -2.62268e-07L45.5 -1.96701e-07Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 32C37.6559 32 37.3208 32.0287 36.9964 32.0831C35.3623 32.3572 33.8155 31.2548 33.5413 29.6208C33.2672 27.9868 34.3696 26.4399 36.0036 26.1658C36.6548 26.0565 37.3219 26 38 26C44.6274 26 50 31.3726 50 38C50 44.6274 44.6274 50 38 50C31.3726 50 26 44.6274 26 38C26 36.8483 26.1631 35.7296 26.4694 34.6682C26.9287 33.0763 28.5916 32.1582 30.1835 32.6176C31.7754 33.077 32.6935 34.7398 32.2342 36.3318C32.0823 36.8579 32 37.4168 32 38C32 41.3137 34.6863 44 38 44C41.3137 44 44 41.3137 44 38C44 34.6863 41.3137 32 38 32Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExplorer);
export default __webpack_public_path__ + "static/media/ic_explorer.c2307b6ca40ef518ed84ba241abc13e4.svg";
export { ForwardRef as ReactComponent };